import { environment } from "../environments/environment";

export type returnUrlsIndex = {
  vgnHeaderFooterJS: string,
  vgnHeaderFooterStyle: string,
  adobeTargetAntiFlickerJS: string,
  adobeDataLayer: string,
  adobeLaunch: string,
  c3Config: string,
  medalliaLib: string,
}

export class EnvironmentConfig {
  private poid: string;
  private secureSiteApiUrl: string;
  private apiUrl: string;
  private logonUrl: string;
  private logonRedirectUrl: string;
  private vgnHeaderFooterJS: string;
  private vgnHeaderFooterStyle: string;
  private adobeTargetAntiFlickerJS: string;
  private adobeDataLayer: string;
  private adobeLaunch: string;
  private medalliaLib: string;
  private watchlistUrl: string;
  private c3Config: string;

  constructor(private redirectUrl: string) {
    this.logonRedirectUrl = redirectUrl;
    this.setUrlsByEnvironment(environment.location);
  }

  private setUrlsByEnvironment(environment: string): void {
    switch (environment) {
      case 'prod-ext':
        this.apiUrl = 'https://personal1.vanguard.com/usa/api/fwl-funds-watchlist-api/api';
        this.secureSiteApiUrl = 'https://personal1.vanguard.com/usa/api/fwl-funds-watchlist-api/';
        this.logonUrl = 'https://logon.vanguard.com?TARGET_OVERRIDE=';
        this.vgnHeaderFooterJS= 'https://n4v.web.vanguard.com/secure-site-components.js';
        this.vgnHeaderFooterStyle= 'https://n4v.web.vanguard.com/nav-preload.css';
        this.adobeTargetAntiFlickerJS= 'https://corp.at2.assets.vgdynamic.info/files/js/core/antiflicker-v2.min.js';
        this.adobeDataLayer= 'https://personal1.vanguard.com/laa-ret-etm-adobe-launch-webapp/static/';
        this.adobeLaunch= 'https://corp.etm.assets.vgdynamic.info/files/retail_global_prd/379f26abac75/9d4ec58961b2/launch-ecb7d9153f04.min.js';
        this.medalliaLib= 'https://mdl-medallia-digital.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js';
        this.watchlistUrl = 'https://funds-watchlist.web.vanguard.com/';
        this.c3Config= `const cccConfig = {
          site: 'retailExternal' ,
          rte: 'PROD',
          app: 'FWF',
          concerns: 'al,it,adv4',
          appConfig: {
            appdynamicskey: "AD-AAB-ACD-FBR",
          }
        };

        window.c3bundle && c3bundle.loadC3Bundle(cccConfig);`;
        break;
      case 'eng-ext':
        this.apiUrl = 'https://devpersonal1.vanguard.com/usa/api/fwl-funds-watchlist-api/api';
        this.secureSiteApiUrl = 'https://devpersonal1.vanguard.com/usa/api/fwl-funds-watchlist-api/';
        this.logonUrl = 'https://devlogon.vanguard.com/logon?TARGET_OVERRIDE=';
        this.vgnHeaderFooterJS= 'https://n4v.webt.vanguard.com/secure-site-components.js';
        this.vgnHeaderFooterStyle= 'https://n4v.webt.vanguard.com/nav-preload.css';
        this.adobeTargetAntiFlickerJS= 'https://corp.at2.testassets.vgdynamic.info/files/js/core/antiflicker-v2.min.js';
        this.adobeDataLayer= 'https://satpersonal1.vanguard.com/laa-ret-etm-adobe-launch-webapp/static/';
        this.adobeLaunch= 'https://corp.etm.testassets.vgdynamic.info/files/retail_global/379f26abac75/9d4ec58961b2/launch-a98aa489c83b-staging.min.js';
        this.medalliaLib= 'https://mdl-medallia-digital-angular-external.ecs.us-east-1.esst.c1.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js';
        this.watchlistUrl = 'https://funds-watchlist.webt.vanguard.com/';
        this.c3Config= `const cccConfig = {
          site: 'retailExternal' ,
          rte: 'ENG',
          app: 'FWF',
          concerns: 'al,it,adv4',
          appConfig: {
            appdynamicskey: "AD-AAB-ACD-FBR",
          }
        };

        window.c3bundle && c3bundle.loadC3Bundle(cccConfig);`;
        break;
      case 'e2e':
        this.apiUrl = 'https://satpersonal1.vanguard.com/usa/api/fwl-funds-watchlist-api/api';
        this.secureSiteApiUrl = 'https://satpersonal1.vanguard.com/usa/api/fwl-funds-watchlist-api/';
        this.logonUrl = 'https://satlogon.vanguard.com?TARGET_OVERRIDE=';
        this.vgnHeaderFooterJS = 'https://n4v.webt.vanguard.com/secure-site-components.js';
        this.vgnHeaderFooterStyle = 'https://n4v.webt.vanguard.com/nav-preload.css';
        this.adobeTargetAntiFlickerJS = 'https://corp.at2.testassets.vgdynamic.info/files/js/core/antiflicker-v2.min.js';
        this.adobeDataLayer = 'https://satpersonal1.vanguard.com/laa-ret-etm-adobe-launch-webapp/static/';
        this.adobeLaunch = 'https://corp.etm.testassets.vgdynamic.info/files/retail_global/379f26abac75/9d4ec58961b2/launch-a98aa489c83b-staging.min.js';
        this.medalliaLib = 'https://mdl-medallia-digital-angular-external.ecs.us-east-1.esst.c1.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js';
        this.watchlistUrl = 'https://funds-watchlist.webt.vanguard.com/';
        this.c3Config = `const cccConfig = {
          site: 'retailExternal' ,
          rte: 'SAT',
          app: 'FWF',
          concerns: 'al,it,adv4',
          appConfig: {
            appdynamicskey: "AD-AAB-ACD-FBR",
          }
        };

        window.c3bundle && c3bundle.loadC3Bundle(cccConfig);`;
        break;
      default:
        this.apiUrl = 'api';
        this.secureSiteApiUrl = '';
        this.logonUrl = 'https://satlogon.vanguard.com?TARGET_OVERRIDE=';
        this.vgnHeaderFooterJS = 'https://n4v.webt.vanguard.com/secure-site-components.js';
        this.vgnHeaderFooterStyle = 'https://n4v.webt.vanguard.com/nav-preload.css';
        this.adobeTargetAntiFlickerJS = 'https://corp.at2.testassets.vgdynamic.info/files/js/core/antiflicker-v2.min.js';
        this.adobeDataLayer = 'https://satpersonal1.vanguard.com/laa-ret-etm-adobe-launch-webapp/static/';
        this.adobeLaunch = 'https://corp.etm.testassets.vgdynamic.info/files/retail_global/379f26abac75/9d4ec58961b2/launch-a98aa489c83b-staging.min.js';
        this.medalliaLib = 'https://mdl-medallia-digital-angular-external.ecs.us-east-1.esst.c1.vanguard.com/pkg/1.0.0/web/external_libs/wdcusprem/2940/onsite/medallia-digital-embed.js';
        this.watchlistUrl = 'https://funds-watchlist.webt.vanguard.com/';
        this.c3Config = `const cccConfig = {
          site: 'retailInternal' ,
          rte: 'DEV',
          app: 'FWF',
          concerns: 'al,it,adv4',
          appConfig: {
            appdynamicskey: "AD-AAB-ACD-FBR",
          }
        };

        window.c3bundle && c3bundle.loadC3Bundle(cccConfig);`;
        break;
    }
  }

  public getSecureSiteApiUrl(): string {
    return this.secureSiteApiUrl;
  }

  public getApiUrl(): string {
    return this.apiUrl;
  }

  public getLogonUrl(): string {
    return this.logonUrl;
  }

  public getLogonRedirectUrl(): string {
    return this.logonRedirectUrl;
  }

  public getAllUrlsIndexTransform(): returnUrlsIndex {
    return {
      vgnHeaderFooterJS: this.vgnHeaderFooterJS,
      vgnHeaderFooterStyle: this.vgnHeaderFooterStyle,
      adobeTargetAntiFlickerJS: this.adobeTargetAntiFlickerJS,
      adobeDataLayer: this.adobeDataLayer,
      adobeLaunch: this.adobeLaunch,
      c3Config: this.c3Config,
      medalliaLib: this.medalliaLib
    }
  }

  public getPoid(): string {
    return this.poid;
  }

  public setPoid(poid: string): void {
    this.poid = poid;
  }

  public getWatchlistUrl(): string {
    return this.watchlistUrl;
  }
}
